// Renders a string, or an array mixing strings and `{ label, url }` links,
// so copy kept in the dictionaries can carry inline links.
export function RichText({ content }) {
  if (!Array.isArray(content)) {
    return content;
  }

  return content.map((part, index) =>
    typeof part === 'string' ? (
      part
    ) : (
      <a key={`${part.label}-${index}`} href={part.url}>
        {part.label}
      </a>
    )
  );
}
